import {
  Company_Read_Typeahead,
  getV1CompaniesCompanyIdCompaniesTypeahead,
  GetV1CompaniesCompanyIdCompaniesTypeaheadData,
} from '@treadinc/horizon-api-spec';
import { FieldValues } from 'react-hook-form';

import { CompanyTypeahead } from '~hooks/useCompany/models';

import AsyncAutocompleteField from '../v2/Autocomplete/AsyncAutocompleteField';
import { CommonAsyncAutocompleteFieldProps } from '../v2/Autocomplete/types';

type Props<T extends FieldValues> = CommonAsyncAutocompleteFieldProps<
  T,
  Company_Read_Typeahead,
  CompanyTypeahead,
  GetV1CompaniesCompanyIdCompaniesTypeaheadData
> & { companyId: string };

export default function AutocompleteScopedCompaniesTypeahead<T extends FieldValues>({
  companyId,
  ...rest
}: Props<T>) {
  return (
    <AsyncAutocompleteField
      {...rest}
      queryName={`AutocompleteScopedCompaniesTypeahead_${companyId}`}
      fetchFn={{
        arguments: { path: { 'company-id': companyId } },
        request: getV1CompaniesCompanyIdCompaniesTypeahead,
      }}
      parseFn={(item: Company_Read_Typeahead) => {
        const parsed = CompanyTypeahead.parse(item);

        return { _entity: parsed, label: parsed.legalName, value: parsed.id };
      }}
    />
  );
}
